export function getElementType(id: string): elementType {
  return id.split("_").pop() as elementType;
}

export function getTreeNodeElement(
  id: string,
  element: calculationElement
): treeElement {
  return {
    title: element.name,
    elementType: getElementType(id),
    children: [],
    id: id
  };
}

export function getBreadcrumbElement(
  id: string,
  element: calculationElement
): breadcrumpElement {
  const type = getElementType(id);
  return {
    title: element.name,
    id: id,
    type: type,
    route: {
      name: "calculations-" + type,
      params: { nodeId: id }
    }
  };
}

export function getPartTree(element: calculationElement): {
  manufacturingTreeNode: treeElement;
  manufacturingBreadcrumb: breadcrumpElement;
  variantTreeNode: treeElement;
  variantBreadcrumb: breadcrumpElement;
} {
  const manufacturingName = element.manufacturing_step_name
    ? element.manufacturing_step_name
    : element.name + " - Manufacturing Step";

  const manufacturingTreeNode = {
    title: manufacturingName,
    elementType: "manufacturingStep" as elementType,
    children: [], //createHierachy(child.children, location, []),
    id: element.id + "_manufacturingStep"
  };

  const manufacturingBreadcrumb = {
    title: manufacturingName,
    id: manufacturingTreeNode.id,
    type: manufacturingTreeNode.elementType as elementType,
    route: {
      name: "calculations-manufacturingStep",
      params: { nodeId: manufacturingTreeNode.id }
    }
  };

  const variantName = element.variant_name
    ? element.variant_name
    : element.name + " - Variant";

  const variantTreeNode = {
    title: variantName,
    elementType: "variant" as elementType,
    children: [manufacturingTreeNode],
    id: element.id + "_variant"
  };

  const variantBreadcrumb = {
    title: variantName,
    id: variantTreeNode.id,
    type: variantTreeNode.elementType as elementType,
    route: {
      name: "calculations-variant",
      params: { nodeId: variantTreeNode.id }
    }
  };

  return {
    manufacturingTreeNode,
    manufacturingBreadcrumb,
    variantTreeNode,
    variantBreadcrumb
  };
}
